export const adminWebsocketCommands = {
    //route (commands)

    // SUPPORT
    ADMIN_USER_SETTINGS_SET: 'setUserSettings',

    //receive

};
